import React from "react";

function DropdownWithLabel(props){

    const reportChange = (e) => {
        if(!props.onChange){
            return;
        }
        props.onChange(e.target.value);
    }

    return (
        <div className={"pt-4 block"}>
            <label className={"text-white"} htmlFor={props.fieldName}>{props.fieldLabel}</label>
            <br />
            <select
                className={"w-full rounded-md mt-2 px-3 py-2"}
                id={props.fieldName}
                name={props.fieldName} {...props.register(props.fieldName, {required: ('required' in props) ? props.required : true })}
                onChange={reportChange}
                disabled={props.disabled}
            >
                {props.children}
            </select>
            {props.errors[props.fieldName]?.type === "required" && <div className={"text-red-500"}>Required</div>}
        </div>
    );
}

export default DropdownWithLabel;
